import { Component, OnInit } from '@angular/core';
import { FormBuilderBasicInputComponentModel } from '../../models/form-builder-basic-input-component-model';

@Component({
  selector: 'tf-core-fb-basic-input-date-input',
  templateUrl: './fb-basic-input-date-input.component.html',
  styleUrls: ['./fb-basic-input-date-input.component.css']
})
export class FbCoreBasicInputDateInputComponent extends FormBuilderBasicInputComponentModel implements OnInit {
    public data = {
        component: null,
        editorData: '',
        editorActive: false,
        hasChanges: false,
        viewType: 'default',
        toggleTooltips: false,
        formGroup: null,
        controlName: ''
    };

    constructor(
    ) {
        super();
    }

    ngOnInit(): void {
        super.init();
    }

}
